/**
 * @owner @Appboy/intelligence
 */

import templatableUtil from "@lib/liquid/templatableUtil";

import { isRcsImageEligibleMessageShape } from "./isRcsImageEligibleMessageShape";
import { detectFileExtensionFromUrl } from "./pushImageVariantRules";
import type { RcsImageEligibilityInput } from "./types";

// Matches RcsMediaFormGroup image acceptedFormats; RCS MEDIA also supports video/audio/pdf.
const rcsImageAcceptedExtensions = new Set(["jpeg", "jpg", "gif", "png"]);

const isRcsImageMediaUrl = (mediaUrl: string | null | undefined): boolean => {
  const trimmedUrl = mediaUrl?.trim();
  if (!trimmedUrl || templatableUtil.hasLiquid(trimmedUrl)) {
    return true;
  }

  const extension = detectFileExtensionFromUrl(trimmedUrl);
  if (!extension) {
    return true;
  }

  return rcsImageAcceptedExtensions.has(extension);
};

export const isRcsImageEligibleMessage = (message: RcsImageEligibilityInput | null | undefined): boolean => {
  if (!message || !isRcsImageEligibleMessageShape(message)) {
    return false;
  }

  return isRcsImageMediaUrl(message.rcs_message?.media_url);
};
